var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("批量投保")))])]), _c("div", {
    staticClass: "itemBox"
  }, [_c("div", {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.$t("批量投保模版")))]), _c("div", {
    staticClass: "right",
    staticStyle: {
      "align-items": "center"
    }
  }, [_c("a-input", {
    staticClass: "upload-input-btn",
    attrs: {
      disabled: ""
    },
    model: {
      value: _vm.batchTemplateName,
      callback: function ($$v) {
        _vm.batchTemplateName = $$v;
      },
      expression: "batchTemplateName"
    }
  }, [_c("a-upload", {
    attrs: {
      slot: "addonAfter",
      action: _vm.action,
      multiple: false,
      "file-list": _vm.fileList,
      showUploadList: false,
      headers: {
        "X-Dispatch": "Upload",
        "X-Version": "upload"
      },
      data: {
        module: "batchTemplate"
      },
      accept: "application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    on: {
      change: _vm.handleChange
    },
    slot: "addonAfter"
  }, [_c("span", {
    staticClass: "uploadBtn"
  }, [_vm._v(_vm._s(_vm.$t("选择文件")))])])], 1), _c("span", {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("*" + _vm._s(_vm.$t("仅支持上传xlsx格式文件，最大不超5M")))]), _vm.batchTemplateName ? _c("span", {
    staticStyle: {
      margin: "10px 0 0 20px",
      color: "red",
      cursor: "pointer"
    },
    on: {
      click: _vm.delBatch
    }
  }, [_vm._v(_vm._s(_vm.$t("删除文件")))]) : _vm._e()], 1)]), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("投保模版")))])]), _c("div", {
    staticClass: "lm",
    staticStyle: {
      position: "relative",
      "margin-bottom": "30px"
    }
  }, [_c("div", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      click: _vm.addTemplate
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t("增加投保模版")))]), _c("a-table", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    style: _vm.showAll ? "" : "max-height:509px;overflow:hidden",
    attrs: {
      size: "small",
      tableLayout: "fixed",
      pagination: false,
      rowKey: "id",
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.insureTableData
    },
    scopedSlots: _vm._u([{
      key: "isRequired",
      fn: function (text, record) {
        return [_c("a-checkbox", {
          attrs: {
            checked: record.isRequired === 1 ? true : false
          },
          on: {
            change: e => _vm.changeIs(e, record, "isRequired")
          }
        })];
      }
    }, {
      key: "isTag",
      fn: function (text, record) {
        return [_c("a-checkbox", {
          attrs: {
            checked: record.isTag === 1 ? true : false
          },
          on: {
            change: e => _vm.changeIs(e, record, "isTag")
          }
        })];
      }
    }, {
      key: "control",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(_vm.controlFun(text)) + " ")];
      }
    }, {
      key: "operation",
      fn: function (_, record, index) {
        return [_c("a-button", {
          staticStyle: {
            "margin-right": "20px"
          },
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.delList(record, index, "insure");
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]), _vm.isNumber(record) || record.control == "time" ? _c("a-button", {
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.onSettingCli(record, index, "insure");
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("高级设置")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots, _item$slots2, _item$slots3;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots = item.slots) === null || _item$slots === void 0 ? void 0 : _item$slots.title
      },
      slot: (_item$slots2 = item.slots) === null || _item$slots2 === void 0 ? void 0 : _item$slots2.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots3 = item.slots) === null || _item$slots3 === void 0 ? void 0 : _item$slots3.title)))]);
  }), 0), _vm.insureTableData.length ? _c("div", [_c("span", {
    staticStyle: {
      color: "#a6a6a6",
      "margin-right": "10px"
    }
  }, [_vm._v("*" + _vm._s(_vm.$t("数据保存后模版将应用到实际投保流程中")))]), _c("span", {
    staticStyle: {
      cursor: "pointer"
    },
    on: {
      click: function ($event) {
        return _vm.previewCli("insure");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("预览模版")))])]) : _vm._e(), _vm.insureTableData.length > 10 ? _c("span", {
    staticStyle: {
      "font-size": "16px",
      position: "absolute",
      bottom: "-30px",
      left: "50%",
      transform: "(0px -50%)"
    },
    on: {
      click: function ($event) {
        _vm.showAll = !_vm.showAll;
      }
    }
  }, [_vm._v(_vm._s(_vm.showAll ? _vm.$t("收起全部") : _vm.$t("展开全部")) + " "), _c("a-icon", {
    style: _vm.showAll ? "transform: rotate(-90deg)" : "transform: rotate(90deg)",
    attrs: {
      type: "double-right"
    }
  })], 1) : _vm._e()], 1), _c("top-title", [_c("span", {
    attrs: {
      slot: "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.$t("退保模版")))])]), _c("div", {
    staticClass: "lm",
    staticStyle: {
      position: "relative",
      "margin-bottom": "30px"
    }
  }, [_c("div", {
    staticStyle: {
      "margin-bottom": "20px"
    },
    on: {
      click: _vm.addPolicyCancelTemplate
    }
  }, [_vm._v("+ " + _vm._s(_vm.$t("增加退保模版")))]), _c("a-table", {
    staticStyle: {
      "margin-bottom": "10px"
    },
    style: _vm.showAllCancel ? "" : "max-height:509px;overflow:hidden",
    attrs: {
      size: "small",
      tableLayout: "fixed",
      pagination: false,
      rowKey: "id",
      bordered: "",
      columns: _vm.columns,
      "data-source": _vm.cancelInsureTableData
    },
    scopedSlots: _vm._u([{
      key: "isRequired",
      fn: function (text, record) {
        return [_c("a-checkbox", {
          attrs: {
            checked: record.isRequired === 1 ? true : false
          },
          on: {
            change: e => _vm.changeIs(e, record, "isRequired")
          }
        })];
      }
    }, {
      key: "isTag",
      fn: function (text, record) {
        return [_c("a-checkbox", {
          attrs: {
            checked: record.isTag === 1 ? true : false
          },
          on: {
            change: e => _vm.changeIs(e, record, "isTag")
          }
        })];
      }
    }, {
      key: "control",
      fn: function (text) {
        return [_vm._v(" " + _vm._s(_vm.controlFun(text)) + " ")];
      }
    }, {
      key: "operation",
      fn: function (_, record, index) {
        return [_c("a-button", {
          staticStyle: {
            "margin-right": "20px"
          },
          attrs: {
            size: "small",
            type: "danger"
          },
          on: {
            click: function ($event) {
              return _vm.delList(record, index, "cancelInsure");
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("删除")))]), _vm.isNumber(record) ? _c("a-button", {
          attrs: {
            size: "small",
            type: "primary"
          },
          on: {
            click: function ($event) {
              return _vm.onSettingCli(record, index, "cancelInsure");
            }
          }
        }, [_vm._v(_vm._s(_vm.$t("高级设置")))]) : _vm._e()];
      }
    }])
  }, _vm._l(_vm.columns, function (item, i) {
    var _item$slots4, _item$slots5, _item$slots6;
    return _c("span", {
      key: i,
      attrs: {
        slot: (_item$slots4 = item.slots) === null || _item$slots4 === void 0 ? void 0 : _item$slots4.title
      },
      slot: (_item$slots5 = item.slots) === null || _item$slots5 === void 0 ? void 0 : _item$slots5.title
    }, [_vm._v(_vm._s(_vm.$t((_item$slots6 = item.slots) === null || _item$slots6 === void 0 ? void 0 : _item$slots6.title)))]);
  }), 0), _vm.cancelInsureTableData.length ? _c("div", [_c("span", {
    staticStyle: {
      color: "#a6a6a6",
      "margin-right": "10px"
    }
  }, [_vm._v("*" + _vm._s(_vm.$t("数据保存后模版将应用到实际投保流程中")))]), _c("span", {
    staticStyle: {
      cursor: "pointer"
    },
    on: {
      click: function ($event) {
        return _vm.previewCli("cancelInsure");
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("预览模版")))])]) : _vm._e(), _vm.cancelInsureTableData.length > 10 ? _c("span", {
    staticStyle: {
      "font-size": "16px",
      position: "absolute",
      bottom: "-30px",
      left: "50%",
      transform: "(0px -50%)"
    },
    on: {
      click: function ($event) {
        _vm.showAllCancel = !_vm.showAllCancel;
      }
    }
  }, [_vm._v(_vm._s(_vm.showAllCancel ? _vm.$t("收起全部") : _vm.$t("展开全部")) + " "), _c("a-icon", {
    style: _vm.showAllCancel ? "transform: rotate(-90deg)" : "transform: rotate(90deg)",
    attrs: {
      type: "double-right"
    }
  })], 1) : _vm._e()], 1), _c("div", {
    staticClass: "btnBox"
  }, [_c("a-button", {
    staticStyle: {
      "margin-right": "20px"
    },
    on: {
      click: _vm.prevFun
    }
  }, [_vm._v(_vm._s(_vm.$t("上一步")))]), _c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.nextFun
    }
  }, [_vm._v(_vm._s(_vm.$t("下一步")))])], 1), _c("a-modal", {
    attrs: {
      title: _vm.$t("高级设置"),
      maskClosable: false
    },
    on: {
      cancel: function ($event) {
        _vm.setVisible = false;
      }
    },
    model: {
      value: _vm.setVisible,
      callback: function ($$v) {
        _vm.setVisible = $$v;
      },
      expression: "setVisible"
    }
  }, [_c("div", {
    staticClass: "setting"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("手机号验证码")) + "：")]), _c("a-radio-group", {
    model: {
      value: _vm.settingCode,
      callback: function ($$v) {
        _vm.settingCode = $$v;
      },
      expression: "settingCode"
    }
  }, [_c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: 1
    }
  }, [_vm._v(_vm._s(_vm.$t("发送")))]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: 0
    }
  }, [_vm._v(_vm._s(_vm.$t("不发送")))])], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSaveSetting
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 2), _c("a-modal", {
    attrs: {
      title: _vm.$t("高级设置"),
      maskClosable: false
    },
    on: {
      cancel: function ($event) {
        _vm.setTimeVisible = false;
      }
    },
    model: {
      value: _vm.setTimeVisible,
      callback: function ($$v) {
        _vm.setTimeVisible = $$v;
      },
      expression: "setTimeVisible"
    }
  }, [_c("div", {
    staticClass: "setting"
  }, [_c("div", [_vm._v(_vm._s(_vm.$t("选择时间控件")) + "：")]), _c("a-radio-group", {
    model: {
      value: _vm.advancedConfig,
      callback: function ($$v) {
        _vm.advancedConfig = $$v;
      },
      expression: "advancedConfig"
    }
  }, [_c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "Ymd"
    }
  }, [_vm._v(_vm._s(_vm.$t("年")) + "-" + _vm._s(_vm.$t("月")) + "-" + _vm._s(_vm.$t("日")) + " ")]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "YmdH"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("年")) + "-" + _vm._s(_vm.$t("月")) + "-" + _vm._s(_vm.$t("日")) + " " + _vm._s(_vm.$t("时")) + " ")]), _c("a-radio", {
    style: _vm.radioStyle,
    attrs: {
      value: "YmdHi"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("年")) + "-" + _vm._s(_vm.$t("月")) + "-" + _vm._s(_vm.$t("日")) + " " + _vm._s(_vm.$t("时")) + ":" + _vm._s(_vm.$t("分")) + " ")])], 1)], 1), _c("template", {
    slot: "footer"
  }, [_c("a-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: _vm.onSaveTimeSetting
    }
  }, [_vm._v(_vm._s(_vm.$t("保存")))])], 1)], 2), _vm.addVisible ? _c("templateModal", {
    attrs: {
      visible: _vm.addVisible,
      title: _vm.templateType == 1 ? _vm.$t("投保模版") : _vm.$t("退保模版"),
      typeListData: _vm.templateType == 1 ? _vm.typeList : _vm.cancelTypeList,
      tempTableData: _vm.templateType == 1 ? _vm.insureTableData : _vm.cancelInsureTableData
    },
    on: {
      "update:visible": function ($event) {
        _vm.addVisible = $event;
      },
      onSave: _vm.onSave
    }
  }) : _vm._e(), _c("preview-mobile", {
    attrs: {
      visible: _vm.previewVisible,
      info: _vm.templateType == 1 ? _vm.insureTableData : _vm.cancelInsureTableData
    },
    on: {
      cancel: function ($event) {
        _vm.previewVisible = false;
      }
    }
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };